const numOfBytesInMegabyte = 1000000;

const bytesToMegabytes = (bytes: number) =>
  Math.floor(bytes / numOfBytesInMegabyte);

export default bytesToMegabytes;
